// Shared display helpers for the Store / Procurement dashboards (bars show "PKR 1.2M" style amounts).
export const pkrShort = (n) => {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1000000) {
    return `PKR ${(v / 1000000).toFixed(1)}M`;
  }
  if (Math.abs(v) >= 1000) {
    return `PKR ${(v / 1000).toFixed(1)}K`;
  }
  return `PKR ${Math.round(v).toLocaleString()}`;
};

export const pkrFull = (n) => `PKR ${Math.round(Number(n) || 0).toLocaleString()}`;

// rows: [{...,value}] -> adds amount (text), max (largest value) and a colour per row, keeping the original keys.
export const withBars = (rows, colors) => {
  const max = Math.max(1, ...rows.map((r) => Number(r.value) || 0));
  return rows.map((r, i) => ({
    ...r,
    amount: pkrShort(r.value),
    max,
    color: colors[i % colors.length],
  }));
};

export const dmy = (iso) => {
  const d = String(iso || "")
    .slice(0, 10)
    .split("-");
  return d.length === 3 ? `${d[2]}/${d[1]}/${d[0]}` : "";
};
